var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediaCommunications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 80",
    style: {
      enableBackground: "new 0 0 66 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#82DECF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object",
    transform: "translate(-429 -2566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object-2",
    transform: "translate(429 2566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    className: "st0",
    d: "M36.1,80H6.2C2.8,80,0,77.2,0,73.8c0,0,0,0,0,0V6.2C0,2.8,2.8,0,6.2,0c0,0,0,0,0,0h29.9 c3.4,0,6.2,2.8,6.2,6.2c0,0,0,0,0,0v15.2c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2V6.2c0-2.1-1.7-3.7-3.7-3.7c0,0,0,0,0,0 H6.2c-2.1,0-3.7,1.7-3.7,3.7c0,0,0,0,0,0v67.5c0,2.1,1.7,3.7,3.7,3.8c0,0,0,0,0,0h29.9c2.1,0,3.7-1.7,3.7-3.7c0,0,0,0,0,0V59.4 c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2v14.4C42.3,77.2,39.6,80,36.1,80C36.1,80,36.1,80,36.1,80"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    x: 0.3,
    y: 10,
    className: "st0",
    width: 41.7,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    x: 1.5,
    y: 67.5,
    className: "st0",
    width: 40.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_124"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    className: "st0",
    d: "M25.2,7.5h-8.1c-0.7,0-1.2-0.6-1.2-1.2S16.4,5,17.1,5h8.1c0.7,0,1.2,0.6,1.2,1.2 S25.9,7.5,25.2,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    className: "st0",
    d: "M21.2,72.5c-0.7,0-1.2,0.6-1.2,1.2c0,0.7,0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2 c0-0.3-0.1-0.6-0.4-0.9C21.8,72.6,21.5,72.5,21.2,72.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    className: "st0",
    d: "M32.3,49.3c-0.7,0-1.2-0.6-1.2-1.3c0-0.3,0.1-0.5,0.2-0.7c2.9-4.1,2.9-9.5,0-13.5 c-0.4-0.6-0.2-1.3,0.4-1.7c0.5-0.4,1.3-0.2,1.7,0.3c3.5,4.9,3.5,11.5,0,16.4C33.1,49.1,32.7,49.3,32.3,49.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    className: "st0",
    d: "M40.9,53.7c-0.7,0-1.2-0.6-1.2-1.3c0-0.2,0.1-0.5,0.2-0.7c4.3-6.9,4.3-15.6,0-22.5 c-0.4-0.6-0.2-1.4,0.4-1.7c0.6-0.4,1.4-0.2,1.7,0.4c4.7,7.7,4.7,17.5,0,25.2C41.7,53.5,41.3,53.7,40.9,53.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    className: "st0",
    d: "M49.8,58.3c-0.4,0-0.9-0.2-1.1-0.6c-0.2-0.4-0.2-0.9,0-1.2c5.7-9.8,5.7-22,0-31.8 c-0.3-0.6,0-1.4,0.6-1.7c0.6-0.3,1.2-0.1,1.6,0.4c6.2,10.6,6.2,23.8,0,34.4C50.7,58.1,50.3,58.3,49.8,58.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    className: "st0",
    d: "M59.1,63.1c-0.4,0-0.9-0.2-1.1-0.6c-0.2-0.4-0.2-0.9,0-1.2c7.3-12.9,7.3-28.6,0-41.5 c-0.3-0.6-0.1-1.4,0.5-1.7s1.4-0.1,1.7,0.5c7.7,13.6,7.7,30.3,0,43.9C60,62.9,59.6,63.1,59.1,63.1"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    className: "st0",
    d: "M435.2,2646c-3.4,0-6.2-2.8-6.2-6.2c0,0,0,0,0,0v-67.5c0-3.4,2.8-6.2,6.2-6.2c0,0,0,0,0,0 h29.9c3.4,0,6.2,2.8,6.2,6.2c0,0,0,0,0,0v15.2c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2c0,0,0,0,0,0v-9h-37.4v55h37.4v-8.1 c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2c0,0,0,0,0,0v14.4c0,3.4-2.8,6.2-6.2,6.2c0,0,0,0,0,0L435.2,2646z M431.5,2639.8 c0,2.1,1.7,3.7,3.7,3.8l0,0h29.9c2.1,0,3.7-1.7,3.7-3.7c0,0,0,0,0,0v-3.8h-37.4V2639.8z M432.6,2569.6c-0.7,0.7-1.1,1.7-1.1,2.7 v3.8h37.4v-3.8c0-2.1-1.7-3.7-3.7-3.7c0,0,0,0,0,0h-29.9C434.2,2568.5,433.3,2568.9,432.6,2569.6L432.6,2569.6z M449.3,2640.6 c-0.5-0.5-0.5-1.3,0-1.8c0.5-0.5,1.3-0.5,1.8,0c0.5,0.5,0.5,1.3,0,1.8c-0.2,0.2-0.5,0.4-0.9,0.4 C449.8,2641,449.5,2640.9,449.3,2640.6L449.3,2640.6z M487.1,2628.5c-0.2-0.4-0.2-0.9,0-1.2c7.3-12.9,7.3-28.6,0-41.5 c-0.3-0.6-0.1-1.4,0.5-1.7c0.6-0.3,1.4-0.1,1.7,0.5c7.7,13.6,7.7,30.3,0,43.9c-0.3,0.6-1.1,0.8-1.7,0.5 C487.3,2628.9,487.2,2628.7,487.1,2628.5L487.1,2628.5z M478.8,2624.3c-0.4,0-0.9-0.2-1.1-0.6c-0.2-0.4-0.2-0.9,0-1.2 c5.7-9.8,5.7-22,0-31.8c-0.3-0.6,0-1.4,0.6-1.7c0.5-0.3,1.2-0.1,1.6,0.4c6.2,10.6,6.2,23.8,0,34.4 C479.7,2624.1,479.3,2624.3,478.8,2624.3L478.8,2624.3z M469.9,2619.7c-0.7,0-1.2-0.6-1.2-1.3c0-0.2,0.1-0.5,0.2-0.7 c4.3-6.9,4.3-15.6,0-22.5c-0.4-0.6-0.2-1.4,0.4-1.7c0.6-0.4,1.4-0.2,1.7,0.4c4.7,7.7,4.7,17.5,0,25.2 C470.7,2619.5,470.3,2619.7,469.9,2619.7L469.9,2619.7z M461.3,2615.3c-0.7,0-1.2-0.6-1.2-1.3c0-0.3,0.1-0.5,0.2-0.7 c2.9-4.1,2.9-9.5,0-13.5c-0.4-0.6-0.2-1.3,0.3-1.7c0.6-0.4,1.3-0.2,1.7,0.3c3.5,4.9,3.5,11.5,0,16.4 C462.1,2615.1,461.7,2615.3,461.3,2615.3L461.3,2615.3z M446.1,2573.5c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2h8.1 c0.7,0,1.2,0.6,1.2,1.2s-0.6,1.2-1.2,1.2H446.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaCommunications);
export default __webpack_public_path__ + "static/media/Media & Communications.81a724a8062a6f37f987eb9f43df3a67.svg";
export { ForwardRef as ReactComponent };